module.exports = __webpack_public_path__ + "static/media/ic-account.e6188fd9.svg";